<template>
    <b-overlay :show="showoverlay" rounded="sm">
    <div>
        <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
        <b-alert show dismissible fade v-if='warningmsg' variant='warning'>{{warningmsg}}</b-alert>
        <b-alert show dismissible fade v-if='dangermsg' variant='danger'>{{dangermsg}}</b-alert>

        <div  class="clearfix row no-gutters" v-if="employee_id > 0">            
            <employee-public-info  :key="c_flg"></employee-public-info>
        </div>
        <div class="mt-4 employee-tab p-4 bg-white" :class="{'new-employee-container' : employee_id == 0}">
            <b-tabs v-model="ewtabIndex" pills content-class="" nav-class=" pr-2 m-2" nav-wrapper-class="col-md-9 custom-margin custom-tab-nav ml-auto pl-0">
                                
                <template v-if="ce">
                    <b-tab lazy>
                        <template active v-slot:title>Info</template>                
                        <div class="clearfix">
                            <div class="">
                                <AccountEmployees  v-on:childToParent="getAccountEmployees" :flg="0"></AccountEmployees>
                            </div>
                        </div>
                    </b-tab>
                    
                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Contracts</template>                
                        <div class="clearfix">
                            <div class="">
                                <ContractForm  :flg="0"></ContractForm>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Contracts</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>

                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Investments</template>                
                        <div class="clearfix">
                            <div class="">
                                <EmployeeInvestmentInfo  :flg="0"></EmployeeInvestmentInfo>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Investments</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>

                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>AIT</template>                
                        <div class="clearfix">
                            <div class="">
                                <EmployeeAitInfo  :flg="0"></EmployeeAitInfo>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>AIT</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>



                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Tax Cards</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <tax-cards ></tax-cards>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Tax Cards</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>
                    
                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Pay Slips</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <employeepayslips ></employeepayslips>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Pay Slips</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>
                   
                    
      

                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Rent Free Accommodation</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <EmployeeRfcInfo  :flg="0"></EmployeeRfcInfo>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Rent Free Accommodation</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>

                    <b-tab lazy v-if="employee_id > 0">
                        <template active v-slot:title>Migrated Payroll History</template>                
                        <div class="clearfix">
                            <div class="">                            
                                <EmployeeMphInfo  :flg="0"></EmployeeMphInfo>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab disabled v-else>
                        <template  v-slot:title>Migrated Payroll History</template>                
                        <div class="clearfix">
                            <div class="">
                                &nbsp;
                            </div>
                        </div>
                    </b-tab>



                    

                </template>
                
            </b-tabs>
        </div>
        <b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
            <keep-alive>
                <SearchEmployees ></SearchEmployees>
            </keep-alive>
        </b-modal>
    </div>
    </b-overlay>
</template>
<script>
    import AccountEmployees from './AccountEmployees';
    import ContractForm from './ContractForm';
    import EmployeeInvestmentInfo from './EmployeeInvestmentInfo';
    import EmployeeAitInfo from './EmployeeAitInfo';
    import SearchEmployees from './SearchEmployees';     
    import EmployeeRfcInfo from './EmployeeRfcInfo'; 
    import EmployeeMphInfo from './EmployeeMphInfo'; 

    

    
    export default{
        mounted() {
            this.setTabIndex();
            //this.showoverlay = false;  
            setTimeout(this.showContent , 3000);    
            
        },
        props: ['readonly'],
        components: {
            AccountEmployees, ContractForm, EmployeeInvestmentInfo , EmployeeAitInfo , SearchEmployees , EmployeeRfcInfo , EmployeeMphInfo
        },
        data(){            
            
            return {
                showoverlay : true,
                cu:window.location.href,
                ce : true,
                avatarsrc : null,
                employee_id : 0,
                company_id : 0,
                ewtabIndex : 0,
                employee_exists : 'employee-exists',
                public_info : [{name:'', email:'', jobposition:'', department:'', company:'', join_date:'', contract_expire:''}],
                
                isHovered: false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                c_flg: 0, // This variable is for reloading public info

            }
        },
        methods:{
            
            showContent: function()
            {
                this.showoverlay = false;
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;   
                    if(this.ce == false) this.ewtabIndex = 0;

                }.bind(this));
            }, 
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            getEmployeeData: function(){
                if(!this.checkNet()) return false;
                
                this.c_flg += 1;
                //alert('hi');
                /*axios.get(this.$api_url+'/employee/publicinfo')
                    .then(function (response) {
                        
                        this.public_info = response.data;
                        this.company_id = this.public_info.company_id;
                        this.employee_id = this.public_info.employee_id;
                        
                        this.avatarsrc = this.$api_url+'/avatar/'+ this.company_id + '/' + this.public_info.pic;

                    }.bind(this));*/
            },                        
            handleHover(hovered) {
                
                this.isHovered = hovered
            },
            getAccountEmployees (value) 
            {
                this.employee_id = value.employee_id;
                if(this.employee_id > 0)
                {
                    this.getEmployeeData();
                }                   

            },
            getContractForm (value) 
            {
                this.public_info.contract_expire = value.contract_expire;
            },
            setTabIndex:function(event)
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/employee/getid')
                    .then(function (response) {

                        if(this.ce == false)
                        {
                            this.ewtabIndex = 0;
                            return;
                        }
                        
                        this.employee_id = response.data;
                        
                            let uri = window.location.href.split('?');
                            if (uri.length == 2)
                            {
                                let vars = uri[1].split('&');
                                let getVars = {};
                                let tmp = '';
                                vars.forEach(function(v){
                                    tmp = v.split('=');
                                    if(tmp.length == 2)
                                        getVars[tmp[0]] = tmp[1];
                                });
                                //console.log(getVars['#']);
                                if(getVars['#'])
                                    this.ewtabIndex = parseInt(getVars['#']);
                                
                            }                       
                                            

                    }.bind(this));                

            },
        },
        created: function(){
            //
            //this.getAcl();
            this.getEmployeeData();
            //this.setTabIndex();
        }

    }

</script>
